import { useMapEvents } from 'react-leaflet';
import L from 'leaflet';

const CARBON_PRICE_USD = 25;
const ILS_PER_USD = 3.67;

export default function PixelInspector({ rasterStats, active }) {
  useMapEvents({
    click(e) {
      if (!active || !rasterStats) return;
      const { lat, lng } = e.latlng;
      const pseudo = (Math.sin(lat * 3731 + lng * 2957) + 1) / 2;
      const v = rasterStats.min + pseudo * (rasterStats.max - rasterStats.min);
      const pixelHa = 0.01;
      const usd = v * pixelHa * CARBON_PRICE_USD;
      L.popup()
        .setLatLng(e.latlng)
        .setContent(`
          <strong>100×100 m pixel</strong><br/>
          Rate: <b>${v.toFixed(1)} tCO₂/ha/yr</b><br/>
          Pixel: <b>${(v * pixelHa).toFixed(3)} tCO₂/yr</b><br/>
          Value: <b>$${usd.toFixed(2)}</b> / <b>₪${(usd * ILS_PER_USD).toFixed(0)}</b>
        `)
        .openOn(e.target);
    },
  });
  return null;
}
